import RedoUndo from './redo-undo';
import ZoomController from './zoom-controller';

const components = [RedoUndo, ZoomController];

const install = function(Vue) {
  if (install.installed) return;
  components.map((component) => Vue.component(component.name, component ));
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export {
  install,
  RedoUndo,
  ZoomController
};

export default {
  install,
  RedoUndo,
  ZoomController
}